import { Button, Shadow, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { Text, Box } from 'native-base';
import React from 'react';

import { FooterTableTypes } from '.';

export const FooterTableMobile: React.FC<FooterTableTypes.Props> = ({ onCancel, onSend }) => {
  return (
    <Shadow
      level={2}
      testId="footer-table-mobile"
      backgroundColor={Color['neutral.white']}
      paddingX={Spacing['stack.xxxs']}
      paddingY={Spacing['stack.xs']}
      marginX={`-${Spacing['stack.xxs']}`}
      marginBottom={`-${Spacing['stack.xxs']}`}
      minHeight="fit-content"
      flex={1}
      borderTopRadius={BoxRadius.sm}>
      <VStack flex={1}>
        <HStack flex={1} space={Spacing['stack.xxxs']}>
          <Box flex={1}>
            <Button backgroundColor="transparent" size="lg" onPress={onCancel}>
              <Text
                fontWeight={Typography['fontweight.semibold']}
                fontSize={Typography['fontsize.md']}
                color={Color['brand.primary.darkest'] as ColorTypes.Option}>
                CANCELAR
              </Text>
            </Button>
          </Box>
          <Box flex={1}>
            <Button onPress={onSend} backgroundColor={Color['feedback.success.default']} size="lg">
              <Text
                fontWeight={Typography['fontweight.semibold']}
                fontSize={Typography['fontsize.md']}
                color={'#ffff' as ColorTypes.Option}>
                ENVIAR
              </Text>
            </Button>
          </Box>
        </HStack>
      </VStack>
    </Shadow>
  );
};
